import { gql } from 'apollo-angular';

export const ConfirmChangeEmailDocument = gql(/* GraphQL*/ `mutation confirmEmailChange($token: String!) {
  confirmEmailChange(token: $token)
}
`);
